import { StaffMissingDocument } from '../../lib/types/models/staff/staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getStaffMissingDocuments = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.staffs.getStaffMissingDocuments.url, { id }))
    .get<StaffMissingDocument[]>()
}
